import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-danger text-lg" }
const _hoisted_2 = { class: "pt-2 italic font-light" }

import GenericModal from '@/components/Layout/Modals/GenericModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorModal',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GenericModal, {
    title: _ctx.$t('ERROR_MODAL_TITLE'),
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
  }, {
    body: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('ERROR_MODAL_SUBTITLE')), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('ERROR_MODAL_BODY')), 1)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})